<template>
	<auto-complete
		:value="value"
		@value="newValue => $emit('value', newValue)"
		:items="items"
		:is-required="isRequired"
		color="primary"
		item-text="text"
		item-value="value"
		:label="$t('common.animal-gender')"
		outlined
		clearable
	></auto-complete>
</template>

<script>
import { AnimalGenderType } from '@/enums';
import AutoComplete from '../default';

export default {
	name: 'AnimalGenderTypeAutoComplete',
	components: {
		AutoComplete,
	},
	props: {
		value: {},
		isRequired: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		items() {
			return AnimalGenderType.getAll().map((animalGenderType) => ({
				text: this.$t(animalGenderType.title),
				value: animalGenderType.value,
			}));
		},
	}
};
</script>